'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "conversation", "selected", "unread", "focused", "ownerState", "slots", "slotProps"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { getDataAttributes } from "../internals/getDataAttributes.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const ConversationListItem = /*#__PURE__*/React.forwardRef(function ConversationListItem(props, ref) {
  const _ref = props,
    {
      children,
      conversation,
      selected = false,
      unread = false,
      focused = false,
      ownerState: ownerStateProp,
      slots,
      slotProps
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  const ownerState = {
    conversation,
    selected,
    unread,
    focused
  };
  void ownerStateProp;
  const Root = slots?.root ?? 'div';
  const rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps?.root,
    externalForwardedProps: other,
    ownerState,
    additionalProps: _extends({
      ref
    }, getDataAttributes({
      selected: ownerState.selected,
      unread: ownerState.unread,
      focused: ownerState.focused
    }))
  });
  return /*#__PURE__*/_jsx(Root, _extends({}, rootProps, {
    children: children
  }));
});
if (process.env.NODE_ENV !== "production") ConversationListItem.displayName = "ConversationListItem";